module.exports = __webpack_public_path__ + "static/media/reactjs.4009eef3.svg";